import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const IntakeEstimateService = {
  async getAlmondcoIntakeVarietySize(RecordId) {
    const requestScreenData = {
      url: "api/AlmondcoIntakeVarietySize",
    };

    if (RecordId) {
      requestScreenData.filter = `RecordId eq ${RecordId}`
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  async getAlmondcoIntakeAvailableVarietySize() {
    const requestScreenData = {
      url: "api/AlmondcoIntakeAvailableVarietySize",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async copyEstimate(payload) {
    var url = `api/AlmondcoIntakeEstimate/${payload.RecordId}/Copy`;
    return await ApiService.post(url, payload);
  },

  async generatePurchaseForecast(payload) {
    var url = `api/AlmondcoIntakeEstimate/GeneratePurchaseForecast`;
    return await ApiService.post(url, payload);
  },

  async saveIntakeEstimate(payload) {
    var url = `api/AlmondcoIntakeEstimate`;
    return await ApiService.post(url, payload);
  },

  async getAlmondcoIntakeEstimate(RecordId) {

    const requestScreenData = {
      url: "api/AlmondcoIntakeEstimate",
      filter: `RecordId eq ${RecordId}`
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getAlmondcoIntakeEstimateVariety(RecordId) {
    const requestScreenData = {
      url: "api/AlmondcoIntakeEstimateVariety",
    };

    if (RecordId) {
      requestScreenData.filter = `IntakeEstimateRecordID eq ${RecordId}`
    }

    return await ApiService.oDataGet(requestScreenData);
  },


  async getAlmondcoIntakeEstimateSize(RecordId) {
    const requestScreenData = {
      url: "api/AlmondcoIntakeEstimateSize",
    };

    if (RecordId) {
      requestScreenData.filter = `IntakeEstimateRecordID eq ${RecordId}`
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  async ApplySizeProfile(season) {
    var requestScreenData = {
      url: `api/AlmondcoIntakeSeasonSizeProfile?filter=((Season eq ${season}))`
    }
    return await ApiService.oDataGet(requestScreenData);
  },
};

export { IntakeEstimateService };
